const data = [
    {
        iduser:"fakepost01",
        description: "Murlock 💖",
        username: "fakeuser01",
        userImg: "https://i.imgur.com/uxVwFyp.jpg",
        src: "https://i.imgur.com/UhOam2M.jpg",
        tags: "ux/ui"
      },
    {
        iduser:"fakepost02",
        description: "¿Cuál es el mejor lenguaje de programación?",
        username: "fakeuser02",
        userImg: "https://i.imgur.com/uxVwFyp.jpg",
        src: "https://i.imgur.com/HqOk7wm.jpg",
        tags: "ux/ui"
      },
    {
        iduser:"fakepost03",
        description: "¿Cuál es el mejor lenguaje de programación?",
        username: "fakeuser03",
        userImg: "https://i.imgur.com/uxVwFyp.jpg",
        src: "https://i.imgur.com/22M1rB2.jpg",
        tags: "ux/ui"
      },
    {
        iduser:"fakepost04",
        description: "¿Cuál es el mejor lenguaje de programación?",
        username: "fakeuser04",
        userImg: "https://i.imgur.com/uxVwFyp.jpg",
        src: "https://i.imgur.com/s7wY3JE.jpg",
        tags: "ux/ui"
      },
    {
        iduser:"fakepost05",
        description: "¿Cuál es el mejor lenguaje de programación?",
        username: "fakeuser05",
        userImg: "https://i.imgur.com/uxVwFyp.jpg",
        src: "https://i.imgur.com/YZWtqUQ.jpg",
        tags: "ux/ui"
      },
    {
        iduser:"fakepost06",
        description: "¿Cuál es el mejor lenguaje de programación?",
        username: "fakeuser06",
        userImg: "https://i.imgur.com/uxVwFyp.jpg",
        src: "https://i.imgur.com/Kse18Zg.jpg",
        tags: "ux/ui"
      },
    {
        iduser:"fakepost07",
        description: "¿Cuál es el mejor lenguaje de programación?",
        username: "fakeuser07",
        userImg: "https://i.imgur.com/uxVwFyp.jpg",
        src: "https://i.imgur.com/ybLGUSQ.jpg",
        tags: "illustration"
      },
    {
        iduser:"fakepost08",
        description: "¿Cuál es el mejor lenguaje de programación?",
        username: "fakeuser08",
        userImg: "https://i.imgur.com/uxVwFyp.jpg",
        src: "https://i.imgur.com/u10EtIP.jpg",
        tags: "illustration"
      },
    {
        iduser:"fakepost09",
        description: "¿Cuál es el mejor lenguaje de programación?",
        username: "fakeuser09",
        userImg: "https://i.imgur.com/uxVwFyp.jpg",
        src: "https://i.imgur.com/X6UJC5c.png",
        tags: "illustration"
      },
    {
        iduser:"fakepost10",
        description: "¿Cuál es el mejor lenguaje de programación?",
        username: "fakeuser10",
        userImg: "https://i.imgur.com/uxVwFyp.jpg",
        src: "https://i.imgur.com/CqFNTny.jpg",
        tags: "trend"
      },
    {
        iduser:"fakepost11",
        description: "¿Cuál es el mejor lenguaje de programación?",
        username: "fakeuser11",
        userImg: "https://i.imgur.com/uxVwFyp.jpg",
        src: "https://i.imgur.com/uDSGH5a.png",
        tags: "trend"
      },
]

export default data